<script setup>
const attrs = useAttrs()
</script>

<template>
  <DevOnly>
    <hr />
    <h3 style="text-transform: none">Name: {{ attrs.componentName }}, Variant: {{ attrs.variant }}</h3>
    <details>
      <summary>Component Data</summary>
      <pre>{{ $attrs }}</pre>
    </details>
  </DevOnly>
</template>

<style>
/* Vite CSS needs a style block */
</style>
